import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UploadWidgetItemSection } from '@shared/utils/enums';
import { BaseResponse, GamesUploadContext, UploadBulkFileResponse, UploadWidgetItemDto } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { gamesBulkUploadUrl } from './games-upload.strategy.constant';
import { UploadSectionStrategy } from './upload-strategy.interface';

@Injectable({ providedIn: 'root' })
export class GamesUploadStrategy implements UploadSectionStrategy {
  readonly section = UploadWidgetItemSection.Games;

  private readonly http = inject(HttpClient);

  upload(file: File, record: UploadWidgetItemDto): Observable<BaseResponse<UploadBulkFileResponse>> {
    const context = record.context as GamesUploadContext;

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<BaseResponse<UploadBulkFileResponse>>(gamesBulkUploadUrl(), formData, {
      params: {
        regionId: context.regionId,
        widgetRecordUuid: record.uuid,
      },
    });
  }
}
